import GrupoAtendimentosCobranca from "./GrupoAtendimentos";
import MeusAtendimentosCobranca from "./MeusAtendimentos";
import TodosAtendimentosCobranca from "./TodosAtendimentos";

export const GestaoAtendimentosCobranca = {
    TodosAtendimentosCobranca,
    GrupoAtendimentosCobranca,
    MeusAtendimentosCobranca,
};
